"use client";

import { usePathname } from "next/navigation";
import Image from "next/image";
import AboutUsLeftVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsLeftVector";
import AboutUsBottomVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsBottomVector";
import AboutUsMiddleVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsMiddleVector";
import AboutUsMobileTopVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsMobileTopVector";
import AboutUsMobileMiddleVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsMobileMiddleVector";
import AboutUsMobileBottomVector from "@/assets/backgroundVectors/bgVectorsComponents/AboutUsMobileBottomVector";
import boardBottomVector from "@/assets/backgroundVectors/boardBottomVector.png";

export default function AboutUsVectors() {
  const pathname = usePathname();

  const isMainAboutUs =
    !pathname.includes("/medarbetare") &&
    !pathname.includes("/styrelse") &&
    !pathname.includes("/agare");
  const isTeam = pathname.includes("/medarbetare");
  const isBoard = pathname.includes("/styrelse");
  const isOwners = pathname.includes("/agare");

  return (
    <>
      <div className="absolute inset-0 overflow-x-clip pointer-events-none">
        {/* Desktop vectors */}
        <AboutUsLeftVector
          className="w-[30%] hidden md:block h-auto text-[#F8EDE3] absolute top-0 left-0 z-1"
          fill="#F8EDE3"
        />
        {isMainAboutUs && (
          <AboutUsBottomVector
            className="w-[35%] hidden md:block h-auto text-[#F8EDE3] absolute bottom-[-12%] right-[-7%] z-1"
            fill="#F8EDE3"
          />
        )}
        {isMainAboutUs && (
          <AboutUsMiddleVector
            className="w-[27%] hidden md:block h-auto text-[#F8EDE3] absolute top-[19%] right-0 z-1"
            fill="#F8EDE3"
          />
        )}
        {isTeam && (
          <>
            <AboutUsMiddleVector
              className="w-[25%] hidden md:block h-auto text-[#F8EDE3] absolute top-[12.7%] right-0 z-1"
              fill="#F8EDE3"
            />
            <AboutUsMiddleVector
              className="w-[28%] hidden md:block h-auto text-[#F8EDE3] absolute top-[49%] right-0 z-1"
              fill="#F8EDE3"
            />
          </>
        )}
        {isBoard && (
          <>
            <AboutUsMiddleVector
              className="w-[26%] hidden md:block h-auto text-[#F8EDE3] absolute top-[18%] right-0 z-1"
              fill="#F8EDE3"
            />
            <Image
              src={boardBottomVector}
              alt=""
              className="w-[28%] hidden md:block h-auto absolute bottom-0 right-0 z-1"
            />
          </>
        )}

        {isOwners && (
          <AboutUsMiddleVector
            className="w-[25%] hidden md:block h-auto text-[#F8EDE3] absolute top-[26%] right-0 z-1"
            fill="#F8EDE3"
          />
        )}

        {/* Mobile vectors */}
        <AboutUsMobileTopVector
          className="w-[50vw] md:hidden h-auto text-[#F8EDE3] absolute top-[40vw] right-0 z-1"
          fill="#F8EDE3"
        />
        <AboutUsMobileMiddleVector
          className="w-[60vw] md:hidden h-auto text-[#F8EDE3] absolute top-[280vw] left-0 z-1"
          fill="#F8EDE3"
        />
        <AboutUsMobileBottomVector
          className="w-[70vw] md:hidden h-auto text-[#F8EDE3] absolute bottom-[90vw] left-0 z-1"
          fill="#F8EDE3"
        />
      </div>
    </>
  );
}
